import { useMemo } from "react";
import { useIsMasterCompany } from "../../../utils/hooks/company";

export const useDrawerProps = ({ mode, help, view, create, transfer, payout, edit, clone, clockInSettings = false }) => {
	const isMaster = useIsMasterCompany();

	const open = useMemo(() => {
		return mode !== "view";
	}, [mode]);

	const title = useMemo(() => {
		switch (mode) {
			case "help":
				return help;
			case "clone":
				return clone;
			case "edit":
				return (isMaster || clockInSettings) ? edit : view;
			case "create":
				return create;
			case "transfer":
				return transfer;
			case "payout":
				return payout;
			default:
				return null;
		}
	}, [mode, isMaster, view, create, edit, clone, help, transfer, payout, clockInSettings]);

	return { title, open };
};
